module.exports = {
	"de": {
		"Alert": "Alarm",
		"Alert duration": "Alarmdauer",
		"Alert duration in percent": "Alarmdauer in Prozent",
		"Alerts of sensors / Sensorhubs": "Alarme der Sensoren / Sensorhubs",
		"Alerts of system": "Alarme am System",
		"Alerts resolved within {minutes} minutes": "Alarme, die innerhalb von {minutes} Minuten behoben wurden",
		"An Error Occured, and a reboot will be required": "Ein Fehler ist aufgetreten und ein Reboot wird benötigt werden",
		"Another running instance of bRCT has been detected": "Eine andere laufenden Instanz von bRCT wurde erkannt",
		"Apply": "Anwenden",
		"Architecture": "Architektur",
		"Average availability of all monitored servers": "Durchschnittliche Verfügbarkeit aller überwachter Server",
		"BIOS": "BIOS",
		"BIOS/MAINBOARD": "BIOS / Mainboard",
		"BLOCKED": "Gesperrt",
		"Build": "Build",
		"COMPANY": "Kunde",
		"CPU": "CPU",
		"Calculation": "Berechnungen",
		"Cancel": "Abbrechen",
		"Capacity": "Kapazität",
		"Categories": "Kategorien",
		"Chassis model": "Chassis Modell",
		"Chassis serial": "Chassis Seriennummer",
		"Choose components from the menu in the editor to create your custom report.": "Wähle im Editor Komponenten aus dem Menü und erstelle so deinen individuellen Bericht.",
		"Choose components from the menu to create your custom report.": "Wähle Komponenten aus dem Menü und editiere Ihre Einstellungen, um deinen eigenen Bericht zu erstellen.",
		"Columns": "Spalten",
		"Comment": "Hinweis",
		"Confirm delete": "Wirklich löschen?",
		"Copy": "Kopie",
		"Cover logo placeholder": "Deckblatt Logo Platzhalter",
		"DESCRIPTION": "Beschreibung",
		"DEVICE": "Gerät",
		"DEVICELOCATOR": "Geräteposition",
		"DEVICEMANUFACTURER": "Hersteller",
		"DEVICEPARTNUMBER": "Artikelnummer",
		"DEVICESIZE": "Größe",
		"DISK": "Laufwerk",
		"DISPLAY": "Anzeige",
		"Database": "Datenbank",
		"Date": "Datum",
		"Date format": "Datumsformat",
		"Disk": "Laufwerk",
		"Display": "Anzeige",
		"Display chart": "Chart anzeigen",
		"Display sensors": "Sensoren anzeigen",
		"Display systems": "Systeme anzeigen",
		"Display table": "Tabelle anzeigen",
		"Distribution over timespan": "Verteilung innerhalb der Zeitspanne",
		"Downloads": "Downloads",
		"Edit": "Bearbeiten",
		"Edition": "Edition",
		"Editor preview is limited to 15 entries": "Die Vorschau ist auf 15 Einträge limitiert",
		"Email": "Email",
		"Empty Sections": "Leere Sektionen",
		"End time": "Endzeit",
		"Error": "Fehler",
		"Event timestamp": "Ereignis Datum",
		"Execution not started because a pending reboot was detected": "Ausführung wurde nicht gestartet, da vorab ein Neustart benötigt wird",
		"Export as XLSX": "Als XLSX exportieren",
		"FAILED": "Fehlgeschlagen",
		"Failed": "Fehlgeschlagen",
		"Failed to initialize extended logging; see logfile for further information": "Failed to initialize extended logging; see logfile for further information ~",
		"False alarm": "Fehlalarm",
		"Filter": "Filter",
		"First reported": "Erste Meldung",
		"Free": "Frei",
		"HOTFIX_ID": "Hotfix-ID",
		"INSTALLDATE": "Uptime",
		"INSTALLED": "Installiert",
		"In progress": "Ausstehend",
		"Info": "Info",
		"Install": "Installationen",
		"Install succeeded, but a reboot will be required": "Installation war erfolgreich, aber es wird ein abschließender Neustart benötigt",
		"Installdate": "Installationsdatum",
		"Is VM?": "Ist VM?",
		"Issue still open": "Alarm weiterhin offen",
		"Job command": "Auftrag",
		"Job not finished": "Auftrag nicht beendet",
		"Job not started": "Auftrag nicht gestartet",
		"LOCALINFO": "Länderinfo",
		"Language": "Sprache",
		"TPM version": "TPM Version",
		"Last boot": "Letztes Hochfahren",
		"Windows 11 compatible": "Windows 11 kompatibel",
		"Windows 11 compatible, Message": "Windows 11 kompatibel, Nachricht",
		"Unknown": "Unbekannt",
		"Last install state": "Letzte Installation",
		"Last job date": "Datum letzter Auftrag",
		"Last reported": "Letzte Meldung",
		"Last scan date": "Letzter Scan",
		"Last scan state": "Letzter Scan",
		"Last shutdown": "Letztes Herunterfahren",
		"ListAlertCountWidget": "Alarme: Pro System",
		"ListAlertSummaryWidget": "Alarme: Zeitliche Verteilung",
		"ListAlertsWidget": "Alarme: Detailliste",
		"ListInventoryWidget": "Inventar",
		"ListMeasurementsWidget": "Messwerte: Pro Sensor",
		"Logonuser": "Anmeldenutzer",
		"MAINBOARD": "Mainboard",
		"MAV thread count": "Anzahl Bedrohungen",
		"MAV.ListEventDaysWidget": "MAV: Bedrohungen pro Tag",
		"MAV.ListEventsWidget": "MAV: Bedrohungen pro System",
		"MAV.ListSystemsWidget": "MAV: Systeme",
		"MEMORYDEVICE": "Speichermodul",
		"MHz": "MHz",
		"Message": "Nachricht",
		"Missing input file for Install or Scan command": "Missing input file for Install or Scan command ~",
		"Missing mandatory parameter; see logfile for further information": "Missing mandatory parameter; see logfile for further information ~",
		"Monitored PCs": "Überwachte PCs",
		"Monitored servers": "Überwachte Server",
		"MonitoringOverviewWidget": "Alarme: SLA Übersicht",
		"Name": "Name",
		"Network": "Netzwerk",
		"No": "Nein",
		"No MAV installed": "Kein MAV installiert",
		"No PM installed": "Kein PM installiert",
		"No SU installed": "SU nicht installiert",
		"No alerts occured": "Es sind keine Alarme aufgetreten.",
		"No alerts where recorded within that timespan": "In diesem Zeitraum wurden keine Alarme festgestellt",
		"No data available": "Es sind keine Daten verfügbar.",
		"No data available for the chosen filter criteria.": "Die gesetzten Filter führen zu keinem Ergebnis. Eventuell gibt es bei diesem Kunden keine Systeme und Sensoren mit den ausgewählten Tags oder andere Einstellungen verhindern ein sinnvolles Ergebnis.",
		"No editor available": "Kein Editor verfügbar",
		"No events occured": "Keine Bedrohungen aufgetreten",
		"No jobs executed": "Keine Aufträge ausgeführt",
		"No managed antivirus": "Kein Managed Antivirus",
		"No measurements available": "Es sind keine Messwerte verfügbar.",
		"No software has been installed": "Es wurde keine Software installiert",
		"No software installation has failed": "Keine Softwareinstallation ist fehlgeschlagen",
		"No software is blocked": "Keine Software wurde gesperrt",
		"No software is planned for installation": "Es ist keine Software zur Installation eingeplant",
		"No threads occured": "Keine Bedrohungen aufgetreten",
		"No threads where detected by the scanner and guard": "Es wurden weder vom Scanner noch vom Guard Bedrohungen gemeldet",
		"No unplanned software available": "Es gibt keine Software ohne Installationsauftrag",
		"None of the selected systems uses managed antivirus": "Keines der gewählten System hat Managed Antivirus aktiviert",
		"Not authenticated": "Nicht angemeldet",
		"Number of processors": "Anzahl Prozessoren",
		"First processor": "Erster Prozessor",
		"OK": "OK",
		"OK duration": "OK-Dauer",
		"OK duration in percent": "OK-Dauer in Prozent",
		"OS": "Betriebssystem",
		"OS Servicepack": "Servicepack",
		"OS install date": "Betriebssystem Installationsdatum",
		"OS language": "Betriebssystem Sprache",
		"OS version": "Betriebssystem Version",
		"OS_HOTFIX": "Betriebssystem Hotfixes",
		"One or more patches failed during installation": "Einer oder mehrere Patches sind bei der Installation fehlgeschlagen",
		"Open as copy": "Als Kopie öffnen",
		"Open empty template": "Leeres Template öffnen",
		"Open template": "Template öffnen",
		"Operating System": "Betriebssystem",
		"Operating systems": "Betriebssysteme",
		"Options": "Optionen",
		"Outdated": "Veraltet",
		"PLANNED": "Geplant",
		"PM.ListJobsWidget": "PM: Aufträge pro System",
		"PM.ListSoftwareWidget": "PM: Software pro System",
		"PM.ListSystemsWidget": "PM: Systeme",
		"PRODUKT": "Produkt",
		"PROGRAMS": "Programme",
		"PageBreakWidget": "Seitenumbruch",
		"Patch": "Update",
		"Planned start time": "Geplante Startzeit",
		"Print preview": "Druckvorschau",
		"Public hints on alerts": "Öffentliche Hinweise zu Alarmen",
		"Report": "Bericht",
		"Report Editor": "Berichtseditor",
		"Resolution": "Auflösung",
		"SU.ListJobsWidget": "SU: Aufträge pro System",
		"SU.ListPatchesWidget": "SU: Updates pro System",
		"SU.ListSystemsWidget": "SU: Systeme",
		"SWVERSION": "Software-Versionen",
		"SYSTEM": "System",
		"Sample data": "Beispieldaten",
		"Save": "Speichern",
		"Saved": "Gespeichert",
		"Saving": "Speichere",
		"Scandate": "Datum letzter Scan",
		"Scans": "Scans",
		"Sensors and systems without alerts": "Sensoren und Systeme ohne Alarme",
		"Sensors without measurements": "Sensoren ohne Messwerte",
		"Server": "Server",
		"Servicepack": "Servicepack",
		"Show summary": "Zusammenfassung anzeigen",
		"Software states without software": "Softwarestatus Listen ohne Software",
		"Start time": "Tatsächliche Startzeit",
		"State": "Status",
		"Successful": "Erfolgreich",
		"Summary": "Zusammenfassung",
		"System manufacturer": "System Hersteller",
		"System model": "System Modell",
		"System type": "Systemtyp",
		"System types": "Systemtypen",
		"System version": "System Version",
		"Systems without MAV": "Systeme ohne Managed Antivirus",
		"Systems without PM": "Systeme ohne Patch Management",
		"Systems without SU": "Systeme ohne Smart Updates",
		"Systems without jobs": "Systeme ohne Aufträge",
		"Systems without patches": "Systeme ohne Updates",
		"Systems without software": "Systeme ohne Software",
		"Systems without threads": "Systeme ohne Bedrohungen",
		"Template name": "Template Name",
		"TextWidget": "Freitext",
		"The following categories had an error while this report was generated": "Die folgenden Kategorien enthielten Updates mit Fehlern während dieser Bericht erzeugt wurde",
		"The following categories were in progress while this report was generated": "Die folgenden Kategorien hatten ausstehende Updates während dieser Bericht erzeugt wurde",
		"The wsusscn2.cab is corrupted and cannot be used for the software scan": "Die Datei wsusscn2.cab ist fehlerhaft und can nicht zum Scan genutzt werden",
		"There were problems with the update": "Es gab Probleme mit dem Update",
		"This is your report canvas.": "Erstelle deinen eigenen Bericht.",
		"This is your report.": "Dies ist dein Bericht.",
		"Thread category": "Bedrohungskategorie",
		"Thread detection module": "Erkennungsmodul",
		"Thread name": "Bedrohungsname",
		"Threshold minutes long": "Langer Schwellwert in Minuten",
		"Threshold minutes short": "Kurzer Schwellwert in Minuten",
		"Title": "Titel",
		"TitleWidget": "Deckblatt",
		"Total RAM (MB)": "Gesamt RAM (MB)",
		"Total alerts": "Gesamtzahl Alarme",
		"Total disk capacity (MB)": "Gesamt Speicherkapazität (MB)",
		"Total disk freespace (MB)": "Gesamt freier Speicher (MB)",
		"Type": "Typ",
		"UNPLANNED": "Ungeplant",
		"Unexpected error, see result file and logfile for further information": "Unexpected error, see result file and logfile for further information ~",
		"Uptime": "Uptime",
		"Used": "Verwendet",
		"With MAV": "Mit Managed Antivirus",
		"With PM": "Mit Patch Management",
		"With SU": "Mit SU",
		"With these tags": "Mit diesen Tags",
		"Without MAV": "Ohne Managed Antivirus",
		"Without PM": "Ohne Patch Management",
		"Without SU": "Ohne SU",
		"Without these tags": "Ohne diese Tags",
		"Workstation": "PC",
		"Yes": "Ja",
		"You are currently not logged in. Please visit https://occ.server-eye.de and log in.": "Du bist aktuell nicht angemeldet. Bitte melde dich erst unter https://occ.server-eye.de an.",
		"bRCT is not startet with administrative permissions": "bRCT wurde nicht mit Administratorrechten gestartet",
		"backup": "Backup",
		"cores": "Kerne",
		"environment": "Umgebung",
		"free": "frei",
		"hardware": "Hardware",
		"is working on this issue": "arbeitet an diesem Alarm",
		"logfiles": "Logdateien",
		"no categories in progress": "Keine Kategorien ausstehend",
		"no categories with errors": "Keine Kategorien mit Fehlern",
		"no patches installed": "Keine Updates installiert",
		"server": "Server",
		"storage": "Speicher",
		"templates": "Templates",
		"until": "bis",
		"virtual": "Virtualisierung",
		"workstation": "PC"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/de.json
// module id = 748
// module chunks = 0 1